import { PreSignedUrl } from '@/models/PreSignedUrl';
import { apiClient } from '@/services/api';
import { logger } from '@/utils/logger/loggerInstance';

export const generatePreSignedUrls = async (requestBody: {
  files: { filename: string; mimeType: string; isExtractable?: boolean; fileSize?: number }[];
  groupId?: string;
  documentUpload?: boolean;
}) => {
  const url = '/files/pre-signed-urls';

  logger.debug(`POST ${url}`);
  const response = await apiClient.post<PreSignedUrl[]>(url, requestBody);

  return response.data;
};
